import { createAction, props } from '@ngrx/store';

// export const callDetailsAdded = createAction('[Call Details Hub] Call Details Added', props<{ callDetail: any }>());

// export const callDetailsUpdated = createAction('[Call Details Hub] Call Details Updated', props<{ callDetail: any }>());

export const systemCallDetailsAdded = createAction('[System] Call Details Added', props<{ callDetail: any }>());
export const systemCallDetailsUpdated = createAction('[System] Call Details Updated', props<{ callDetail: any }>());

export const accountCallDetailsAdded = createAction('[Account] Call Details Added', props<{ callDetail: any }>());
export const accountCallDetailsUpdated = createAction('[Account] Call Details Updated', props<{ callDetail: any }>());

export const presenceCallDetailsAdded = createAction('[Presence] Call Details Added', props<{ callDetail: any }>());
export const presenceCallDetailsUpdated = createAction('[Presence] Call Details Updated', props<{ callDetail: any }>());
